import CtaActions from './CtaActions'

export default CtaActions
